<template>
    <div>
        <div name="breadcrumb-layout" class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>部门领用【部门】</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div name="org-tree">
            <swb-popover-org-tree :showIncludeSubComs="true" :initIncludeSubComs="includeSubComs" @notity-change="notityChange($event)"></swb-popover-org-tree>
        </div>
        <swb-query-sort-area name="query-sort-area" ref="query_sort_area" :confKey="confKey" :queryOnLoad="queryOnLoad" :configAuto="true" :queryHandler="queryHandler"></swb-query-sort-area>
        <div name="btns" class="simple-row">
            <div class="right">
                <button class="swb-btn swb-btn-small swb-btn-primary" @click="download()">
                    <span>导出excel</span>
                </button>
            </div>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="true" :rowNoShow="false" :height="tableHeight" :minColWidth="minColWidth" :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, showPageRangeSelDlg, Routes } from '../../app.vues'
    import { getDefaultPageSizes, getDefaultDownloadPageSize } from '../../app.conf'
    import { showGrpDownloadDlg } from '../ctrl/dialog'

    import userApi from '../../api/user'
    import shopStuffApi from '../../api/shopStuff'

    import SwbPopoverOrgTree from '../orgStruct/PopoverOrgTree';
    Vue.regist(SwbPopoverOrgTree);

    import SwbResultTable from '../query/ResultTable'
    Vue.regist(SwbResultTable);

    export default {
        name: 'retailer-lowcost-apply-use-for-staff',
        path: '/lowcost/apply/use/for/staff',
        desc: '机构内人员领用',
        data: function () {
            return {
                confKey: "retailer-lowcost-apply-use-for-staff",
                queryOnLoad: true,
                //
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                //
                //排序、搜索
                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                //
                thisComId: null,
                thisComLevel: null,
                includeSubComs: false,
                exportParmas: null,
                //
                tableHeight: 300, //表格高度
                minColWidth: 120,
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            //
            this.getCurrentUserInfo();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            thisEl.addClass("overFlow-hidden");
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;
                console.log("qw1" + height);
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="breadcrumb-layout"], [name="org-tree"], [name="query-sort-area"], [name="btns"], [name="tabs"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        beforeDestroy() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            getCurrentUserInfo: function () {
                let self = this;
                let theLoad = MsgBox.loading();
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let data = result.data;
                        let scopeEntity = data.scopeEntity;
                        self.thisComId = scopeEntity.comId;
                        self.thisComLevel = scopeEntity.comLevel;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            initResultTable(){
                let self = this;
                let query_sort_area = this.$refs['query_sort_area'];
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_sort_area);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'quantiy': function (row, colName, colValue, rowIndex, colConf) {
                        // 数量
                        return '<span>' + row.sumQuantiy + '</span>';
                    },
                    'amount': function (row, colName, colValue, rowIndex, colConf) {
                        // 价格(元)
                        return '<span>' + (row.orgWorth != null ? row.orgWorth * row.sumQuantiy : 0.00).toFixed(2) + '</span>';
                    },
                });
            },
            handleTabClick(val){
                let query_model_ctrl = this.$refs['query_sort_area'];
                let data = {hidden: false};
                if(val != "lowCostFlag") {
                    data = {hidden: true};
                }
                let fieldInfo = {};
                fieldInfo['ts'] = data;
                query_model_ctrl.updateFields(fieldInfo);
                //
                this.checkStateValue = val;
                this.pageNumber = 1;
                this.lastPageNumber = null;
                this.getStuffAppturnItemDepartStaffStatis();
            },
            handleTabClickDouble(val){
                this.checkDoubleStateValue = val;
                this.pageNumber = 1;
                this.lastPageNumber = null;
                this.getStuffAppturnItemDepartStaffStatis();
            },
            notityChange: function (eventData) {
                if(eventData.id != this.thisComId || this.includeSubComs != eventData.includeSubComs) {
                    this.thisComLevel = eventData.level;
                    this.thisComId = eventData.id;
                    this.includeSubComs = eventData.includeSubComs;
                    this.pageNumber = 1;
                    this.getStuffAppturnItemDepartStaffStatis();
                }
            },
            queryHandler(queryModel){
                //1、接收查询条件
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.lastPageNumber = null;
                //缓存查询条件
                this.getStuffAppturnItemDepartStaffStatis();
            },
            // 分页切换
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                this.lastPageNumber = null;
                //
                this.getStuffAppturnItemDepartStaffStatis();
            },
            getStuffAppturnItemDepartStaffStatis: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = this.queryModel.filterItems;
                postData.sortItemList = Utils.merge([], this.queryModel.sortItemList);
                postData.sortItems = Utils.merge({}, this.queryModel.sortItems);
                //
                postData.filterItems = filterItems;
                postData.filterItems.comId = self.thisComId;
                postData.filterItems.comLevel = self.thisComLevel;
                postData.filterItems.includeSubComs = self.includeSubComs;
                self.exportParmas = postData.filterItems;
                let theLoad = MsgBox.loading();
                shopStuffApi.getStuffAppturnItemDepartStaffStatis(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let itemList = result.data.rows || [];
                        //
                        self.totalCount = result.data.pagination.totalCount;
                        self.renderTable(itemList, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 渲染数据
            renderTable(rows, pagination) {
                //let resultColConfCmp = this.$refs['result_col_conf'];
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                // let confColList = resultColConfCmp.getMetaColList();
                //resultTable.initMeta(confColList);
                let dataMap = {
                    pagination: pagination,
                    rows: rows
                };
                //设置新数据
                resultTable.render(dataMap);
            },
            download: function () {
                let self = this;
                let pageSize = getDefaultDownloadPageSize();
                let pages = Math.ceil(this.totalCount / pageSize);
                if(pages > 10) {
                    showPageRangeSelDlg("选择导出文件序号", pages, 10, this.lastPageNumber, function (ok, range) {
                        if(ok) {
                            if(range.to == pages) {
                                self.lastPageNumber = 0;
                            } else {
                                self.lastPageNumber = range.to;
                            }
                            //
                            self.exportPrintData(pageSize, range.from, range.to);
                        }
                    }, {pageSize: pageSize})
                } else {
                    self.exportPrintData(pageSize);
                }
            },
            exportPrintData(pageSize, fromPages, toPages){
                let title = "耗材管理";
                let pages = Math.ceil(this.totalCount / pageSize);
                //
                fromPages = fromPages == null ? 1 : fromPages;
                toPages = toPages == null ? pages : toPages;
                let tableData = this.getTableData(pages, pageSize);
                //
                let url = getAppUrl("/file/export/as/excel");
                let downloadUrls = [];
                for(let i = fromPages; i <= toPages; i++) {
                    let tmpFile = {};
                    tmpFile.url = url;
                    tmpFile.post = true;
                    tmpFile.fileName = title + (pages == 1 ? '' : ("_" + (i + 1)));
                    tmpFile.seqNo = i;
                    //
                    let data = Utils.merge({}, tableData);
                    data.pageNumber = i;
                    data.fileName = tmpFile.fileName;
                    tmpFile.data = data;
                    downloadUrls.push(tmpFile);
                }
                title = title + '-下载| 每个文件' + pageSize + '条数据';
                showGrpDownloadDlg(title, downloadUrls);
            },
            getTableData(pages, pageSize){
                let resultTable = this.$refs.result_table;
                let tableData = resultTable.getTableData(true);
                delete tableData.rows;//减少数据传输量
                //
                let rowsSrc = {};
                rowsSrc.data = this.getPostData();
                rowsSrc.url = "/shop/stuff/appturn/voucher/item/depart/staff/statis/get";
                tableData.rowsSrc = rowsSrc;
                //
                tableData.pageSize = pageSize;
                tableData.pageCount = this.totalCount;
                tableData.pages = pages;
                return tableData;
            },
            getPostData(){
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, this.exportParmas);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                let postData = {};
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                return postData;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/easyReport/LowCostApplyUseForStaff.vue